import {
  DeepPartial,
  IDefaultRetailerSettingsVersion2,
  IMobileSettings,
  ISharedSettings,
} from '@thryveai/theme-interfaces';
import { IGrowthBookFeatures } from 'growthbook/growthbook.interfaces';

export type FeaturesToPromoteConfig = {
  /** Storefront features - promoted based on retailer settings */
  storefront: {
    [key: string]: {
      condition: DeepPartial<IDefaultRetailerSettingsVersion2>;
      title: string;
      description: string;
      docsLink: string;
    };
  };
  /** Mobile features - promoted based on mobile settings */
  mobile: {
    [key: string]: {
      condition: DeepPartial<IMobileSettings>;
      title: string;
      description: string;
      docsLink: string;
    };
  };
  /** Shared features - promoted based on shared settings */
  shared: {
    [key: string]: {
      condition: DeepPartial<ISharedSettings>;
      title: string;
      description: string;
      docsLink: string;
    };
  };
  /** GrowthBook features - promoted when ALL listed feature flags are enabled */
  growthbook: {
    [key: string]: {
      condition: (keyof IGrowthBookFeatures)[];
      title: string;
      description: string;
      docsLink: string;
    };
  };
};

/**
 * Configuration for features to be promoted.
 * Each feature entry contains:
 * - key: The key of the feature that will be used as identifier
 * - condition: The criteria that must be met across all retailer banners for the feature to be promoted
 * - title: Display name for the feature
 * - description: Brief description of what the feature does
 * - docsLink: Link to documentation for the feature
 * 
 * Condition examples:
 * - Settings: { siteSettings: { useContentEngineV2Components: { SmallPromotion: false } } }
 *   → Promote if SmallPromotion is not enabled in the retailer settings
 * - GrowthBook: ['dev-cms-components', 'dev-carousel-redesign']
 *   → Promote if all feature flags in the array are enabled
 */
export const featuresToPromoteConfig: FeaturesToPromoteConfig = {
  storefront: {},
  mobile: {},
  shared: {},
  growthbook: {},
};
